import React from 'react';
import { func, string, bool } from 'prop-types';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import { GC_1 } from 'utils/constants/BackgroundId';
import * as styles from './styles/styles.module.scss';
import GiftCard from '../GiftCard';

const GiftCardRadioButtons = ({ onChange, selectedVariant, valentinesDayVariant }) => {
  const languageRegionCode = useLanguageRegionCode();

  const variants = valentinesDayVariant
    ? [GC_1, `gc-2-${languageRegionCode}`, `v-day-${languageRegionCode}`]
    : [GC_1, `gc-2-${languageRegionCode}`, `gc-3-${languageRegionCode}`];

  return (
    <div className={styles.container}>
      {variants.map(variant => {
        return (
          <div key={variant} className={styles.cardRadioContainer}>
            <input
              value={variant}
              onChange={onChange}
              name="backgroundId"
              className={styles.radioButton}
              id={variant}
              type="radio"
              checked={selectedVariant === variant}
            />
            <label htmlFor={variant} className={styles.label}>
              <GiftCard backgroundId={variant} classes={styles.small} />
            </label>
          </div>
        );
      })}
    </div>
  );
};

GiftCardRadioButtons.propTypes = {
  onChange: func,
  selectedVariant: string,
  valentinesDayVariant: bool
};

GiftCardRadioButtons.defaultProps = {
  onChange: () => {},
  selectedVariant: '',
  valentinesDayVariant: false
};

export default GiftCardRadioButtons;
